import { useQueryClient } from "@tanstack/react-query";
import {
  PatientAssessment,
  PatientAssessmentControllerApi,
} from "../../../services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "../../../utils/utils";

/**
 * @author [Rajkumar Rathod]
 */
export const usePatientAssessmentCreate = () => {
  const queryClient = useQueryClient();
  return useMutationWithLoading(
    async (params: {
      patientAssessment: PatientAssessment;
      xTENANTID?: string;
    }) =>
      new PatientAssessmentControllerApi(getConfigObject()).createDepartment(
        params.patientAssessment,
        params.xTENANTID || getXtenantId()
      ),
    {
      // Creating a patient assessment surfaces a new entry in the chart
      // timeline + may add a requiring action — invalidate both so the
      // Provider Timeline reflects the change without a tab switch.
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["chronological-record"] });
        queryClient.invalidateQueries({ queryKey: ["requiring-action"] });
      },
    }
  );
};
